import {
	getOwnPersonalInfo,
	updateOwnPersonalInfo as putOwnPersonalInfo,
	updateOwnPassword as changePassword,
	getCompanyUsers as getCompanyUsersData,
	postCreateUser,
	deleteUser,
	getCompany,
	putCompany,
	getClient,
	getBrand,
	getMarket,
	postClient,
	postBrand,
	postMarket,
	deleteMarket,
	deleteBrand,
	deleteClient,
	putClient,
	putBrand,
	getBillingData,
	putMarket,
	postUploadLogo,
	updateOtherUserPersonalInfoData,
	postUserPermission,
	deleteUserPermission,
	getMenubar,
} from "../../../helpers/backend_helper";
import {
	getCompanySuccess,
	getCompanyError,
	getOwnPersonalInfoSuccess,
	getOwnPersonalInfoErr,
	getUserListSuccess,
	getUserListError,
	passwordChangeSuccess,
	passwordChangeError,
	inviteUserError,
	getClientSuccess,
	getBrandSuccess,
	getMarketSuccess,
	getBillingSuccess,
	setClientErr,
	setBrandErr,
	setMarketErr,
	setCompanyErr,
} from "./reducer";
import { loginSuccess } from "../login/reducer";
import { getMenuData } from "../menu/thunk";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { addPermission, getPermissionList, removePermission } from "../permission/thunk";
import { toast } from "react-toastify";
import { replace } from "redux-first-history";
import {checkMaintenance} from '../login/helper';

/**
 * Redux action creator for fetching the user's own personal information.
 * @function
 * @async
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
 */
export const ownPersonalInfo = createAsyncThunk("settings/getOwnPersonalInfoData", async (data, { dispatch, getState }) => {
	try {
		let response = await getOwnPersonalInfo();
		return response.data;
	} catch (error) {
		checkMaintenance(dispatch, error);
	}
})

/**
* Redux action creator for updating the user's own personal information.
* @function
* @async
* @param {Object} data - The updated personal information to be sent to the server.
* @param {string} data.firstName - The updated first name.
* @param {string} data.lastName - The updated last name.
* @param {string} data.jobTitle - The updated job title.
* @param {function} dispatch - The Redux dispatch function.
* @param {function} getState - The function to get the current Redux state.
* @throws {Error} If there is an issue with the asynchronous operation.
*/
export const updateOwnPersonalInfo = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const { token, userId } = getState().Login.user.data;
		const company = getState().MenuData.client;
		let picture = (data?.picture ? data?.picture : null);
		if (data.hasOwnProperty('picture') && typeof data?.picture === 'object' && data.picture !== null) {
			// console.log(data);
			const pictureRes = await dispatch(uploadLogo(data.picture, company._id));
			if (pictureRes.status === 'ok' && (pictureRes.data[0][0] !== undefined || pictureRes.data[0][0] !== null)) {
				picture = pictureRes.data[0][0];
			} else {
				throw pictureRes;
			}
		}
		let response = await putOwnPersonalInfo({ ...data, userId, picture: picture }, { token, userId });
		if (response.status === 'ok') {
			dispatch(ownPersonalInfo());
			dispatch(loginSuccess({
				status: "ok",
				data: {
					firstName: data.firstName,
					lastName: data.lastName,
					role: data.jobTitle,
					token: token,
					userId: userId,
					picture: picture
				}
			}));
			toast.success(language[response.code], { autoClose: 3000 });
			return true;
		} else {
			throw response;
		}

	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(getOwnPersonalInfoErr(language[error?.code]));
		return false;
	}
};
/**
 * Redux action creator for updating the user's own password.
 * @function
 * @async
 * @param {Object} data - The new password data to be sent to the server.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
*/
export const updateOwnPassword = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		let response = await changePassword(data);
		if (response.status === 'ok') {
			dispatch(passwordChangeSuccess(language[response.code]));
		} else {
			dispatch(passwordChangeError(language[response.code]));
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(passwordChangeError(language[error?.code]));
	}
};

/**
 * Redux action creator for fetching details of the user's associated company.
 * @function
 * @async
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
 */
export const getCompanyDetails = () => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		let response = await getCompany();
		if (response.status === 'ok') {
			dispatch(getCompanySuccess(language[response.code]));
			dispatch(getBillings());		
		} else {
			throw response;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(getCompanyError(language[error?.code]));
	}
};

/**
 * Redux action creator for updating company details associated with the user.
 * @function
 * @async
 * @param {Object} data - The updated company details to be sent in the request.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
 */
export const updateCompany = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const { client } = getState().MenuData;
		let logo = data.logo;
		let logoRes;
		if (typeof logo === "object" && logo !== null) {
			logoRes = await dispatch(uploadLogo(logo, client._id));
			if (logoRes.status === 'ok' && (logoRes.data[0][0] !== undefined || logoRes.data[0][0] !== null)) {
				logo = logoRes.data[0][0];
			} else {
				throw logoRes;
			}
		}

		let response = await putCompany({ ...data, logo: logo });
		if (response.status === 'ok') {
			dispatch(getMenuData());
			return true;
		} else {
			throw response;
		}
		// dispatch(getCompanyDetails());
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(setCompanyErr(language[error?.code]));
	}
};

/**
 * Redux action creator for fetching the list of clients associated with the user.
 * @function
 * @async
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
*/
export const getClientList = createAsyncThunk("settings/getClientsData", async (data, { dispatch, getState }) => {
	try {
		const company = getState().MenuData.client;
		let response = await getClient({ companyId: company._id });
		return response.data;
	} catch (error) {
		checkMaintenance(dispatch, error);
	}
})

/**
 * Redux action creator for adding a new client.
 * @function
 * @async
 * @param {Object} data - The data representing the new client.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
 */
export const addClient = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const company = getState().MenuData.client;
		let logo = data.logo;
		if (typeof logo === "object" && logo !== null) {
			const logoRes = await dispatch(uploadLogo(data.logo, company._id));
			if (logoRes.status === 'ok' && (logoRes.data[0][0] !== undefined || logoRes.data[0][0] !== null)) {
				logo = logoRes.data[0][0];
			} else {
				throw logoRes;
			}
		}
		let response = await postClient({
			...data,
			logo: logo,
			companyId: company._id
		});
		if (response.status === 'ok') {
			await dispatch(getPermissionList());
			const clientList = await dispatch(getClientList());
			await dispatch(getMenuData());
			dispatch(replace(window.location.href, clientList.payload));
			return true;
		} else {
			throw response;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(setClientErr(language[error?.code]));
	}
}

/**
 * Redux action creator for removing a client.
 * @function
 * @async
 * @param {string} data - The ID of the client to be removed.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
 */
export const removeClient = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		let response = await deleteClient({ id: data });
		if (response.status === 'ok') {
			const clientList = await dispatch(getClientList());
			dispatch(getMenuData());
			dispatch(getClientSuccess(clientList.payload));
			dispatch(replace(window.location.href, clientList.payload));
			toast.success(language[response.code], { autoClose: 3000 });
		} else {
			throw response;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		toast.error(language[error?.code], { autoClose: 3000 });
	}
}

/**
 * Redux action creator for updating a client.
 * @function
 * @async
 * @param {Object} data - The data representing the updated client.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
 */
export const updateClient = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const company = getState().MenuData.client;
		let logo = data.logo;
		if (typeof logo === "object" && logo !== null) {
			const logoRes = await dispatch(uploadLogo(data.logo, data._id));
			if (logoRes.status === 'ok' && (logoRes.data[0][0] !== undefined || logoRes.data[0][0] !== null)) {
				logo = logoRes.data[0][0]
			} else {
				throw logoRes;
			}
		}

		let response = await putClient({
			...data,
			id: data._id,
			logo: logo,
			companyId: company._id
		});
		if (response.status === 'ok') {
			const clientList = await dispatch(getClientList());
			await dispatch(getMenuData());
			dispatch(replace(window.location.href, clientList.payload));
			return true;
		} else {
			throw response;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(setClientErr(language[error?.code]));
	}
}

/**
 * Redux action creator for retrieving a list of brands associated with a client.
 * @function
 * @async
 * @param {string} clientId - The unique identifier of the client.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
 */
export const getBrandList = createAsyncThunk("settings/getBrandsData", async (clientId, { dispatch, getState }) => {
	try {
		let response = await getBrand({ clientId: clientId });
		return response.data;
	} catch (error) {
		checkMaintenance(dispatch, error);
	}
})

/**
 * Redux action creator for adding a new brand associated with a client.
 * @function
 * @async
 * @param {Object} data - The data representing the new brand to be added.
 * @param {string} clientId - The unique identifier of the client to associate the new brand with.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
 */
export const addBrand = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const { clientPath, title } = getState().MenuData;
		let logo = data.logo;
		if (typeof logo === "object" && logo !== null) {
			const logoRes = await dispatch(uploadLogo(data.logo, clientPath));
			if (logoRes.status === 'ok' && (logoRes.data[0][0] !== undefined || logoRes.data[0][0] !== null)) {
				logo = logoRes.data[0][0];
			} else {
				throw logoRes;
			}
		}

		let response = await postBrand({
			...data,
			logo: logo,
		});
		if (response.status === 'ok') {
			if (data.markets.length > 0) {
				const marketRes = await dispatch(addMarket({
					markets: data.markets,
					webSite: data.webSite,
					brandId: response.data.insertedId
				}));
				if (typeof marketRes === 'object') {
					throw marketRes;
				}
			}
			await dispatch(getPermissionList());
			const brandList = await dispatch(getBrandList(data.clientId));
			await dispatch(getMenuData());
			dispatch(getBrandSuccess(brandList.payload));
			dispatch(replace(window.location.href, { brands: brandList.payload, clientId: data.clientId, title: title }));
			return true;
		} else {
			throw response;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(setBrandErr(language[error?.code]));
	}
};

/**
 * Redux action creator for removing a brand associated with a client.
 * @function
 * @async
 * @param {string} data - The unique identifier of the brand to be removed.
 * @param {string} clientId - The unique identifier of the client from which the brand should be removed.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
 */
export const removeBrand = (data, clientId) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const { title } = getState().MenuData;
		let response = await deleteBrand({ id: data });
		if (response.status === 'ok') {
			const brandList = await dispatch(getBrandList(clientId));
			dispatch(getMenuData());
			dispatch(getBrandSuccess(brandList.payload));
			dispatch(replace(window.location.href, { brands: brandList.payload, clientId: clientId, title: title }));
			toast.success(language[response.code], { autoClose: 3000 });
		} else {
			throw response;
		}

	} catch (error) {
		checkMaintenance(dispatch, error);
		toast.error(language[error?.code], { autoClose: 3000 });
	}
};

/**
 * Redux action creator for updating a brand.
 * @function
 * @async
 * @param {object} data - The data representing the updated brand.
 * @param {string} clientId - The unique identifier of the client associated with the brand.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
*/
export const updateBrand = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const { brandPath, title } = getState().MenuData;
		let logo = data.logo;
		let logoRes;
		if (typeof data.logo === "object" && data.logo !== null) {
			logoRes = await dispatch(uploadLogo(data.logo, brandPath))
			if (logoRes.status === 'ok' && (logoRes.data[0][0] !== undefined || logoRes.data[0][0] !== null)) {
				logo = logoRes.data[0][0];
			} else {
				throw logoRes;
			}
		}

		let response = await putBrand({
			...data,
			logo: logo,
			id: data._id
		});
		if (response.status === 'ok') {
			const brandList = await dispatch(getBrandList(data.clientId));
			await dispatch(getMenuData());
			dispatch(getBrandSuccess(brandList.payload));
			dispatch(replace(window.location.href, { brands: brandList.payload, clientId: data.clientId, title: title }));
			return true;
		} else {
			throw response;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(setBrandErr(language[error?.code]));
	}
};

/**
 * Redux action creator for fetching the market list associated with a specific brand and client.
 * @function
 * @async
 * @param {string} clientId - The unique identifier of the client associated with the market.
 * @param {string} brandId - The unique identifier of the brand associated with the market.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
*/
export const getMarketList = createAsyncThunk("settings/getMarketsData", async (brandId, { dispatch, getState }) => {
	try {
		let response = await getMarket({ brandId: brandId });
		return response.data;
	} catch (error) {
		checkMaintenance(dispatch, error);
	}
})

/**
 * Redux action creator for adding a new market entry.
 * @function
 * @async
 * @param {object} data - The data for the new market entry.
 * @param {string} data.clientId - The unique identifier of the client associated with the market.
 * @param {string} data.brandId - The unique identifier of the brand associated with the market.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
*/
export const addMarket = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const { brands, client } = getState().Settings;
		const { clientPath, title } = getState().MenuData;
		let i = 0;
		do {
			let response = await postMarket({
				name: data.markets[i],
				webSite: data.webSite,
				brandId: data.brandId
			});
			if (response.status !== 'ok') {
				throw response;
			}
			i++;
		} while (i < data.markets.length);
		const marketList = await dispatch(getMarketList(data.brandId));
		dispatch(getMarketSuccess(marketList.payload));
		dispatch(replace(window.location.href, { markets: marketList.payload, brands: brands, brandId: data.brandId, clientId: clientPath, title: title }));
		dispatch(getMenuData());
		// dispatch(getBilling());
		return true;
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(setMarketErr(language[error?.code]));
		return error;
	}
};

/**
 * Redux action creator for removing a market entry.
 * @function
 * @async
 * @param {string} data - The unique identifier of the market entry to be removed.
 * @param {string} clientId - The unique identifier of the client associated with the market.
 * @param {string} brandId - The unique identifier of the brand associated with the market.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
*/
export const removeMarket = (data, clientId, brandId) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const { token, userId } = getState().Login.user.data;
		const { markets, brands } = getState().Settings;
		const { clientPath, brandPath, title } = getState().MenuData;
		let response = await deleteMarket({ id: data }, { token, userId });
		if (response.status === 'ok') {
			const marketList = await dispatch(getMarketList(brandPath))
			dispatch(getMenuData());
			dispatch(getMarketSuccess(marketList.payload));
			dispatch(replace(window.location.href, { markets: marketList.payload, brands: brands, brandId: brandPath, clientId: clientPath, title: title }));
			toast.success(language[response.code], { autoClose: 3000 });
		} else {
			throw response;
		}

		// dispatch(getBilling());
	} catch (error) {
		checkMaintenance(dispatch, error);
		toast.error(language[error?.code], { autoClose: 3000 });
	}
};

/**
 * Redux action creator for updating a market entry.
 * @function
 * @async
 * @param {Object} data - The updated data for the market entry.
 * @param {Object} params - Additional parameters, including marketId, clientId, and brandId.
 * @param {string} params.marketId - The unique identifier of the market entry to be updated.
 * @param {string} params.clientId - The unique identifier of the client associated with the market.
 * @param {string} params.brandId - The unique identifier of the brand associated with the market.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
 */
export const updateMarket = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const { markets, brands, clientPath, title } = getState().Settings;
		let response = await putMarket(data);
		// dispatch(getMarketList(params.clientId, params.brandId));
		if (response.status === 'ok') {
			const marketList = await dispatch(getMarketList(data.brandId));
			dispatch(getMenuData());
			dispatch(getMarketSuccess(marketList.payload));
			dispatch(replace(window.location.href, { markets: marketList.payload, brands: brands, brandId: data.brandId, clientId: clientPath, title: title }));
			return true;
		} else {
			throw response;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(setMarketErr(language[error?.code]));
	}
};

export const uploadLogo = (file, id) => async (dispatch, getState) => {
	try {
		const { client, clientPath, brandPath, marketPath } = getState().MenuData;
		let response = await postUploadLogo({
			files: file,
			relationId: id
		});
		return response;
	} catch (error) {
		return error;
	}
};

export const getBilling = (id) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		let response = await getBillingData(id);
		if (response.status === 'ok') {
			return response;
		} else {
			throw error;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		toast.error(language[error?.code], { autoClose: 3000 });
	}
}

/**
 * Redux action creator for retrieving billing information for the current company.
 * @function
 * @async
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
*/
export const getAllBillings = () => async (dispatch, getState) => {
	try {
		const company = getState().MenuData.client;
		const { clientPath, brandPath } = getState().MenuData;
		let billingIds = [];
		billingIds.push(company.billingId);
		function traverseObject(obj) {
			if (Array.isArray(obj)) {
				obj.forEach(item => traverseObject(item));
			} else if (typeof obj === 'object' && obj !== null) {
				if (obj.hasOwnProperty("billingId")) {
					billingIds.push(obj['billingId']);
				}
				for (let key in obj) {
					traverseObject(obj[key]);
				}
			}
		}
		traverseObject(company.clients);
		let i = 0;
		let billing = [];
		const finalBillingIds = [...new Set(billingIds)];
		if (finalBillingIds.length > 0) {
			do {
				let response = await dispatch(getBilling(finalBillingIds[i]));
				if (response.data[0]) {
					billing.push(response.data[0]);
				}
				i++;
			} while (i < finalBillingIds.length);
		}
		dispatch(getBillingSuccess(billing));
	} catch (error) {
		checkMaintenance(dispatch, error);
	}
};
/**
 * Redux action creator for retrieving a list of users associated with the current company.
 * @function
 * @async
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
 */
export const getCompanyUsers = createAsyncThunk("settings/getCompanyUsersData", async (data, { dispatch, getState }) => {
	try {
		let response = await getCompanyUsersData();
		return response.data
	} catch (error) {
		checkMaintenance(dispatch, error);
	}
})
/** * Redux action creator for creating a new user within the current company.
 * @param {Object} data - The user data to be created.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
*/
export const createUser = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const userPermission = getState().Settings.userPermission;
		let createResponse = await postCreateUser(data);
		if (createResponse.status === 'ok') {
			if (userPermission.length > 0) {
				let i = 0;
				do {
					try {
						let permissionResponse = await dispatch(addPermission({
							userId: createResponse.data.insertedId,
							level: userPermission[i].level,
							relationId: userPermission[i].relationId,
							permissionId: userPermission[i].permissionId
						}));
					} catch (error) {
						throw error;
					}
					i++;
				} while (i < userPermission.length);
			}
			dispatch(getCompanyUsers());
			return true;
		} else {
			throw createResponse;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(inviteUserError(language[error?.code]));
	}
};

export const updateOtherUserPersonalInfo = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const company = getState().MenuData.client;
		const userPermission = getState().Settings.userPermission;
		const user = getState().Login.user;
		let picture = (data?.picture ? data?.picture : null);
		if (data.hasOwnProperty('picture') && typeof data?.picture === 'object') {
			const pictureRes = await dispatch(uploadLogo(data.picture, company._id));
			if (pictureRes.status === 'ok' && (pictureRes.data[0][0] !== undefined || pictureRes.data[0][0] !== null)) {
				picture = pictureRes.data[0][0];
			} else {
				throw pictureRes;
			}
		}
		let response = await updateOtherUserPersonalInfoData({
			firstName: data.firstName,
			lastName: data.lastName,
			email: data.email,
			role: data.role,
			country: data.country,
			city: data.city,
			// phoneNumber: data.phoneNumber,
			joiningDate: data.joiningDate,
			// jobTitle: data.jobTitle,
			userId: data._id,
			picture: picture
		});
		if (response.status === 'ok') {
			if (user.data.userId !== data._id) {
				let currentPermissionRes = await postUserPermission({ id: data._id });
				if (currentPermissionRes.status === 'ok') {
					if (currentPermissionRes.data.length > 0) {
						let i = 0;
						do {
							try {
								let deleteRes = await dispatch(removePermission(currentPermissionRes.data[i]._id));
								if (deleteRes.status !== 'ok') {
									throw deleteRes;
								}
							} catch (error) {
								throw error;
							}
							i++;
						} while (i < currentPermissionRes.data.length);
					}
					if (userPermission.length > 0) {
						let k = 0;
						do {
							try {
								let addRes = await dispatch(addPermission({
									userId: data._id,
									level: userPermission[k].level,
									relationId: userPermission[k].relationId,
									permissionId: userPermission[k].permissionId
								}));
								if (addRes.status !== 'ok') {
									throw addRes;
								}
							} catch (error) {
								throw error;
							}
							k++;
						} while (k < userPermission.length);
					}
				} else {
					throw currentPermissionRes;
				}
			}
			dispatch(getCompanyUsers());
			if (user.data.userId === data._id) {
				const personalRes = dispatch(ownPersonalInfo());
				dispatch(loginSuccess({
					status: "ok",
					data: {
						firstName: data.firstName,
						lastName: data.lastName,
						role: data.role,
						token: user.data.token,
						userId: user.data.userId,
						picture: picture
					}
				}));
			} else {
				toast.success(language[response.code], { autoClose: 3000 });
			}
			return true;
		} else {
			throw response;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(inviteUserError(language[error?.code]));
	}
}

/**
 * Redux action creator for removing a user from the current company.
 * @function
 * @async
 * @param {string} data - The user ID to be removed.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
*/
export const removeUser = (data) => async (dispatch, getState) => {
	const { language } = getState().MenuData;
	try {
		const { token, userId } = getState().Login.user.data;
		let response = await deleteUser({ userId: data }, { token, userId });
		if (response.status === 'ok') {
			dispatch(getCompanyUsers());
			toast.success(language[response.code], { autoClose: 3000 });
		} else {
			throw response;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		toast.error(language[error?.code], { autoClose: 3000 });
	}
};